module.exports = __webpack_public_path__ + "img/IMG_6689_FoamcoreMatted.f9ac3b16.jpg";